import React, {Component} from 'react';
import { Link } from 'react-router-dom';
import '../Brand/brand.css';
import moment from 'moment';
import Gallery from "../Modal/Gallery";
import SVG from "react-inlinesvg";
import modalIcon from "../../assets/modal_icon.svg";
import lock from "../../assets/lock-480x480.png";
import ToolTips from "../Shared/ToolTips";
import whiteStar from "../../assets/Star-white@3x.png";

class SearchRow extends Component {
    constructor(props) {
        super(props);
        this.state = {
            units: [],
            showModal: {
                gallery: false
            },
            gallery_id: false
        }
    }
    toggleModal = (type, show) => {
        this.setState({
            showModal: {
                [type]: show
            }
        })
    };
    galleryInfo = (id) => {
        this.setState({
            gallery_id: id
        })
    }
    filterFuncs = () => {
        let fill = this.props.row.functionalities.filter((f, i) => {
            if(f.name !== "Expandable" && f.name !== "Interstitial"){
                return f;
            }
        })
        return fill.map((functionality, i) => (
            <div key={i}>{functionality.name}</div>
        ))
    }
    ifBulk = () => {
        return this.props.row.display_banner_type === "standard" || this.props.row.creative_type === "Video";
    }
    render() {
        const { row } = this.props;
        return (
            <React.Fragment>
                {this.state.showModal.gallery && <Gallery
                    toggleModal={this.toggleModal}
                    unit={row}
                    active_id={this.state.gallery_id}
                    gallery_Info={this.galleryInfo}
                />}
            <tr>
                <td className="creative-tr">
                        <Link to={`/${row.unit_type}/${row.id}`}>
                            <div className="campaign-image">
                                <img src={row.thumbnail} alt={`unit-${row.unit_type}-${row.id}`}/>
                                {row.unit_type === 'mock' && row.animated === "true" ?  <span className="mocked-icon mocked-icon-btm-left"> </span> :   <span className={`unit-type unit-type--${row.unit_type} unit-type--bottom-left`}>{row.unit_type}</span>}
                            </div>
                        </Link>
                    <div className="tool-wrapper">
                        {row.favorite_id !== null ?
                            (<ToolTips content="Best in Class" data="bic">
                                  <span className="example-emoji" role="img">
                                         <div style={ {background: "#e1ca6c", borderColor: "transparent"} } className="favorite-btn favorite-container"><img src={whiteStar} className="grey-star" alt=""/></div>
                                  </span>
                            </ToolTips>) : ""}
                    </div>
                </td>
                <td>{row.creative_type}</td>
                <td className="underline"><Link to={`/brand/${row.bid}`}>{row.brand_hide === 1 ? <span id="lock-container"><ToolTips content="Hidden Brand" data="hb"><img src={lock} alt="brand is hidden"/></ToolTips></span> : ""} {row.brand}</Link></td>
                <td className="underline"><Link to={`/campaign/${row.cid}`}>{row.campaign}</Link></td>
                <td>
                    {row.verticals.map((vertical, i) => {
                        return <div key={i}>{vertical.name}</div>
                    })}
                </td>
                <td>
                    {row.creative_type === "Rich Media" || row.creative_type === "Rich Media Expandable" || row.creative_type === "Rich Media Interstitial" ? this.filterFuncs() : row.functionalities.map((functionality, i) => (
                        <div key={i}>{functionality.name}</div>
                    ))}
                    {row.functionalities.length > 8 &&
                        (<Link to={`/${row.unit_type}/${row.id}`}><span className="device-link" style={{textDecoration: 'underline'}}>view more...</span></Link>)
                    }
                </td>
                <td>{row.designer}</td>
                <td>{moment(row.date).format('MMMM YYYY')}</td>
                <td className="links-container">
                    {row.unit_type === 'live' && row.demo_links.length > 0 && row.demo_links.map((links, i) => {
                            if(i < 8){
                                return <div key={i}>
                                    <div className="tool-wrapper dl">
                                        <ToolTips content={links.notes !== null ? links.demo_type +" "+ links.notes : links.demo_type } data="device-labels">
                                            <a className="device-link" href={links.url} target="_blank" rel="noopener noreferrer">{links.demo_type}</a>
                                        </ToolTips>
                                    </div>
                                  </div>
                            }
                        })
                    }
                    {row.unit_type === 'live' && this.ifBulk() === true &&
                        row.s3_links.map((links, i) => {
                            if(i < 8){
                                return (
                                    <React.Fragment key={i}>
                                        <div  onClick={() => {this.toggleModal('gallery', true); this.galleryInfo(links.id)}}>
                                            <div className="tool-wrapper dl">
                                                <ToolTips content={links.notes !== undefined ? links.ad_size +" "+ links.notes : links.ad_size } data="device-labels">
                                                    <span className="attached_links search-links">{links.ad_size}
                                                        <SVG src={modalIcon}/>
                                                   </span>
                                                </ToolTips>
                                            </div>
                                        </div>
                                    </React.Fragment>
                                )
                            }
                        })
                    }
                    {row.unit_type === 'live' && row.demo_links.length > 8 &&
                        (<Link to={`/${row.unit_type}/${row.id}`}><span className="device-link" style={{textDecoration: 'underline'}}>view more...</span></Link>)
                    }
                    {row.unit_type === 'live' && row.s3_links.length > 8 &&
                        (<Link to={`/${row.unit_type}/${row.id}`}><span className="device-link" style={{textDecoration: 'underline'}}>view more...</span></Link>)
                    }
                    {row.unit_type === 'mock' &&
                        <div><a className="device-link" href={row.powerpoint} target="_blank" rel="noopener noreferrer">PowerPoint</a></div>
                    }
                </td>
            </tr>
            </React.Fragment>
        )
    }
}

export default SearchRow;
